import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { ISettings } from '../util/DataModelInterface';
import * as storage from '../util/StorageUtil';

export const getSettings = async (force: boolean = false) => {
  let settings = storage.getSettings();
  if (!settings || force) {
    const url = `${getFunctionBaseUrl()}/api/getSettings`;
    const response = await rest.get(url);
    if(response && response.result) {
      storage.setSettings(response.result);
      settings = response.result;
    } else {
      return response;
    }
  }
  return settings;


}

export const modifySettings = async (settings: ISettings) => {
  const url = `${getFunctionBaseUrl()}/api/modifySettings/`;
  const response = await rest.post(url, settings);
  console.log("resp: ", response);
  return response;
}
